<template>
  <nav
    class="navbar is-primary no-print"
    role="navigation"
    aria-label="main navigation"
  >
    <div class="navbar-brand">
      <router-link class="navbar-item" to="/">
        <!-- <img src="@/assets/logo.png" width="30" height="30"> -->
        <span>&nbsp;&nbsp;{{ this.user.username }}</span>
      </router-link>
      <a
        role="button"
        class="navbar-burger"
        aria-label="menu"
        aria-expanded="false"
        :class="{ 'is-active': isMenuActive }"
        @click="isMenuActive = !isMenuActive"
      >
        <span aria-hidden="true"></span>
        <span aria-hidden="true"></span>
        <span aria-hidden="true"></span>
      </a>
    </div>

    <div class="navbar-menu" :class="{ 'is-active': isMenuActive }">
      <div class="navbar-start">
        <!-- <div class="navbar-item has-dropdown is-hoverable">
          <a class="navbar-link">
            <span>ເມູນ 1</span>
          </a>

          <div class="navbar-dropdown">
            <router-link
              @click.native="menuClicked"
              class="navbar-item"
              to="/company/equipmentOrderWaitApproveReport"
              active-class="is-active"
              exact
            >
              <span>ເມູນ 1.1</span>
            </router-link>


            <router-link
              @click.native="menuClicked"
              class="navbar-item"
              to="/company/equipmentPaymentWaitApproveReport"
              active-class="is-active"
              exact
            >
              <span>ເມູນ 1.2</span>
            </router-link>
            <hr class="menu-sperator" />
          </div>
        </div>

        <div class="navbar-item has-dropdown is-hoverable">
          <a class="navbar-link">
            <span>ເມູນ 2</span>
          </a>

          <div class="navbar-dropdown">
            <router-link
              @click.native="menuClicked"
              class="navbar-item"
              to="/company/equipmentOrderWaitApproveReport"
              active-class="is-active"
              exact
            >
              <span>ເມູນ 2.1</span>
            </router-link>

            <router-link
              @click.native="menuClicked"
              class="navbar-item"
              to="/company/equipmentPaymentWaitApproveReport"
              active-class="is-active"
              exact
            >
              <span>ເມູນ 2.2</span>
            </router-link>
            <hr class="menu-sperator" />
          </div>
        </div> -->
      </div>

      <div class="navbar-end">
        <div class="navbar-item has-dropdown is-hoverable">
          <a class="navbar-link">
            <span>ວຽກງານ DASM</span>
          </a>
          <div class="navbar-dropdown">
            <router-link
              @click.native="menuClicked"
              class="navbar-item"
              to="/oapp/dasmplan"
              :exact="true"
              active-class="is-active"
            >
              <span>ແຜນປະຈຳປີ ສັນຍາ B2B</span>
            </router-link>
            <router-link
              @click.native="menuClicked"
              class="navbar-item"
              to="/oapp/dasmreport"
              :exact="true"
              active-class="is-active"
            >
              <span>ລາຍງານທຽບກັບແຜນປະຈຳປີ ສັນຍາ B2B</span>
            </router-link>
            <router-link
              @click.native="menuClicked"
              class="navbar-item"
              to="/oapp/marketplan"
              :exact="true"
              active-class="is-active"
            >
              <span>ແຜນປະຈຳປີ ຕະຫຼາດ</span>
            </router-link>
            <router-link
              @click.native="menuClicked"
              class="navbar-item"
              to="/oapp/marketreport"
              :exact="true"
              active-class="is-active"
            >
              <span>ລາຍງານທຽບກັບແຜນປະຈຳປີ ຕະຫຼາດ</span>
            </router-link>
            <router-link
              @click.native="menuClicked"
              class="navbar-item"
              to="/oapp/saleplan"
              :exact="true"
              active-class="is-active"
            >
              <span>ແຜນປະຈຳປີ ການຂາຍ</span>
            </router-link>
            <router-link
              @click.native="menuClicked"
              class="navbar-item"
              to="/oapp/salereport"
              :exact="true"
              active-class="is-active"
            >
              <span>ລາຍງານທຽບກັບແຜນປະຈຳປີ ການຂາຍ</span>
            </router-link>
            
          </div>
        </div>
        <div class="navbar-item has-dropdown is-hoverable">
          <a class="navbar-link">
            <span>ວຽກງານ DPP</span>
          </a>
          <div class="navbar-dropdown">
            <router-link
              @click.native="menuClicked"
              class="navbar-item"
              to="/oapp/dppplan"
              :exact="true"
              active-class="is-active"
            >
              <span>ກຳນົດແຜນປະຈຳປີ</span>
            </router-link>
            <router-link
              @click.native="menuClicked"
              class="navbar-item"
              to="/oapp/dppreport"
              :exact="true"
              active-class="is-active"
            >
              <span>ລາຍງານທຽບໃສ່ແຜນ</span>
            </router-link>
            <router-link
              @click.native="menuClicked"
              class="navbar-item"
              to="/dpp/b2bcontractplanprogress"
              :exact="true"
              active-class="is-active"
            >
              <span>ຕິດຕາມຄວາມຄືບໜ້າຂອງສັນຍາ</span>
            </router-link>
          </div>
        </div>
        <!-- <div class="navbar-item has-dropdown is-hoverable">
          <a class="navbar-link">
            <span>ວຽກງານ Market</span>
          </a>
          <div class="navbar-dropdown">
            <router-link
              @click.native="menuClicked"
              class="navbar-item"
              to="/oapp/marketplan"
              :exact="true"
              active-class="is-active"
            >
              <span>ກຳນົດແຜນປະຈຳປີ</span>
            </router-link>
            <router-link
              @click.native="menuClicked"
              class="navbar-item"
              to="/oapp/marketreport"
              :exact="true"
              active-class="is-active"
            >
              <span>ລາຍງານທຽບໃສ່ແຜນ</span>
            </router-link>
            <router-link
              @click.native="menuClicked"
              class="navbar-item"
              to="/dpp/b2bcontractplanprogress"
              :exact="true"
              active-class="is-active"
            >
              <span>ຕິດຕາມຄວາມຄືບໜ້າຂອງສັນຍາ</span>
            </router-link>
          </div>
        </div> -->
        <div class="navbar-item has-dropdown is-hoverable">
          <a class="navbar-link">
            <span>ລາຍງານລວມ</span>
          </a>
          <div class="navbar-dropdown">
            <router-link
              @click.native="menuClicked"
              class="navbar-item"
              to="/oapp/report"
              :exact="true"
              active-class="is-active"
            >
              <span>ລາຍງານຊາວກະສິກອນ</span>
            </router-link>
            <router-link
              @click.native="menuClicked"
              class="navbar-item"
              to="/oapp/report"
              :exact="true"
              active-class="is-active"
            >
              <span>ລາຍງານຜົນຜະລິດ</span>
            </router-link>
          </div>
        </div>
        
        <div class="navbar-item has-dropdown is-hoverable">
          <a class="navbar-link">
            <span>ລາຍງານລວມ</span>
          </a>
          <div class="navbar-dropdown">
            <router-link
              @click.native="menuClicked"
              class="navbar-item"
              to="/oapp/report"
              :exact="true"
              active-class="is-active"
            >
              <span>ລາຍງານລວມ</span>
            </router-link>
          </div>
        </div>
        <div class="navbar-item has-dropdown is-hoverable">
          <a class="navbar-link">
            <span>ຕັ້ງຄ່າຕ່າງໆ</span>
          </a>
          <div class="navbar-dropdown">
            <router-link
              @click.native="menuClicked"
              class="navbar-item"
              to="/company/projectSettingProjectsForm"
              :exact="true"
              active-class="is-active"
            >
              <span>ຕັ້ງຄ່າ 1</span>
            </router-link>

            <router-link
              @click.native="menuClicked"
              class="navbar-item"
              to="/company/projectSettingProjectsForm"
              :exact="true"
              active-class="is-active"
            >
              <span>ຕັ້ງຄ່າ 2</span>
            </router-link>
          </div>
        </div>
        <div class="navbar-item has-dropdown is-hoverable">
          <a class="navbar-link">
            <span>ຜູ້ໃຊ້ງານ {{ rolename }}</span>
          </a>
          <div class="navbar-dropdown">
            <router-link
              @click.native="menuClicked"
              class="navbar-item"
              to="/form/userProfile"
              :exact="true"
              active-class="is-active"
            >
              <span>ຂໍ້ມູນສ່ວນຕົວ</span>
            </router-link>

            <router-link
              @click.native="menuClicked"
              class="navbar-item"
              to="/login"
              :exact="true"
              active-class="is-active"
            >
              <span>ອອກຈາກລະບົບ</span>
            </router-link>
          </div>
        </div>
      </div>
    </div>
  </nav>
</template>

<script>
import { get } from "vuex-pathify";

export default {
  name: "ReportMenu",
  data() {
    return {
      isMenuActive: false,
      rolename: null,
    };
  },
  mounted() {
    this.roleid = this.user.ROLEID;
    this.rolename = this.user.ROLENAME;
    console.log("roleid: " + JSON.stringify(this.roleid));
  },
  computed: {
    user: get("loginData"),
  },
  methods: {
    menuClicked() {
      this.isMenuActive = false;
    },
  },
};
</script>

<style scoped>
.navbar-item {
  white-space: nowrap;
}
.navbar-end {
  padding-right: 60px;
}
</style>
